import AuthChecker from '@/components/AuthChecker';
import LoginOTPToggle from '@/components/Toggle/LoginOTPToggle';
import LoginV1 from '@/containers/Login';
import LoginV2 from '@/containers/Login/V2';
import SetupTwoFA from '@/containers/SetupTwoFA';
import { NextPage } from 'next';

const LoginPage: NextPage = () => {
  return (
    <>
      <AuthChecker>
        <LoginOTPToggle v1Component={<LoginV1 />} v2Component={<LoginV2 />} />
      </AuthChecker>
      <SetupTwoFA />
    </>
  )
};

export default LoginPage;
